<template>
  <section id="contact" class="container-fluid Contact">
    <footer class="container">
      <div class="row">
        <div class="col-12 mb-5">
          <h4 class="Section-heading Section-heading--white">Contact Us</h4>
          <h2 class="Contact-cta mb-5">
            <a href="https://ideum.com/contact" class="linkInline--reverse linkInline--reverse--white" target="_blank" rel="noopener">
              Online Inquiry Form
            </a>
          </h2>
          <p>
            <a href="mailto:sales@ideum.com" class="linkInline linkInline--teal" >sales@ideum.com</a> | <a href="tel:1-505-792-1110" class="linkInline linkInline--teal">(505) 792-1110 ext.1</a>
          </p>
          <p>
            toll-free in the US and Canada at <a href="tel:1-855-898-6824" class="linkInline linkInline--teal">(855) 898-6824</a>
          </p>
          <p>
            We sell direct worldwide.
          </p>
        </div>
        <div class="col-md-3 mx-auto mt-md-5 mt-3">
          <a href="http://ideum.com/" target="_blank" rel="noopener">
            <app-logo-ideum
              :height="'35px'"
            />
          </a>
          <p class="Contact-legal mt-4">&copy; Ideum 2017. All rights reserved.</p>
        </div>
      </div>
    </footer>
  </section>
</template>

<script>
import appLogoIdeum from './../components/Logo-ideum'
export default {
  components: {
    appLogoIdeum
  }
}
</script>

<style lang="scss" scoped>
@import './../assets/styles/_variables.scss';

.Contact {
  background-color: $colorBlack;
  color: $colorWhite;
  padding-top: 4em;
  padding-bottom: 1.5em;
  text-align: center;
  @media screen and (min-width: $grid-md) {
    padding-top: 7rem;
    padding-bottom: 2rem; 
  }
  @media screen and (min-width: $grid-lg) {
    padding-top: 10rem;
    padding-bottom: 3rem; 
  }
}

.Contact-cta {
  text-transform: lowercase;
  @media screen and (min-width: $grid-sm) {
    font-size: 2.5em;
  }
  @media screen and (min-width: $grid-xl) {
    font-size: 2.75em;
  }
}

.Contact-legal {
  font-size: .8em;
}
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue